webpackJsonp([114276838955818,60335399758886],{

/***/ 195:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(424);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(195);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(893)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowequal = __webpack_require__(357);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _raf = __webpack_require__(896);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldUpdate2 = __webpack_require__(898);
	
	var _shouldUpdate3 = _interopRequireDefault(_shouldUpdate2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-unresolved
	
	
	var noop = function noop() {};
	
	var Headroom = function (_Component) {
	  _inherits(Headroom, _Component);
	
	  function Headroom(props) {
	    _classCallCheck(this, Headroom);
	
	    // Class variables.
	    var _this = _possibleConstructorReturn(this, (Headroom.__proto__ || Object.getPrototypeOf(Headroom)).call(this, props));
	
	    _this.setRef = function (ref) {
	      return _this.inner = ref;
	    };
	
	    _this.setHeightOffset = function () {
	      _this.setState({
	        height: _this.inner.offsetHeight
	      });
	      _this.resizeTicking = false;
	    };
	
	    _this.getScrollY = function () {
	      if (_this.props.parent().pageYOffset !== void 0) {
	        return _this.props.parent().pageYOffset;
	      } else if (_this.props.parent().scrollTop !== void 0) {
	        return _this.props.parent().scrollTop;
	      } else {
	        return (document.documentElement || document.body.parentNode || document.body).scrollTop;
	      }
	    };
	
	    _this.getViewportHeight = function () {
	      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	    };
	
	    _this.getDocumentHeight = function () {
	      var body = document.body;
	      var documentElement = document.documentElement;
	
	      return Math.max(body.scrollHeight, documentElement.scrollHeight, body.offsetHeight, documentElement.offsetHeight, body.clientHeight, documentElement.clientHeight);
	    };
	
	    _this.getElementPhysicalHeight = function (elm) {
	      return Math.max(elm.offsetHeight, elm.clientHeight);
	    };
	
	    _this.getElementHeight = function (elm) {
	      return Math.max(elm.scrollHeight, elm.offsetHeight, elm.clientHeight);
	    };
	
	    _this.getScrollerPhysicalHeight = function () {
	      var parent = _this.props.parent();
	
	      return parent === window || parent === document.body ? _this.getViewportHeight() : _this.getElementPhysicalHeight(parent);
	    };
	
	    _this.getScrollerHeight = function () {
	      var parent = _this.props.parent();
	
	      return parent === window || parent === document.body ? _this.getDocumentHeight() : _this.getElementHeight(parent);
	    };
	
	    _this.isOutOfBound = function (currentScrollY) {
	      var pastTop = currentScrollY < 0;
	
	      var scrollerPhysicalHeight = _this.getScrollerPhysicalHeight();
	      var scrollerHeight = _this.getScrollerHeight();
	
	      var pastBottom = currentScrollY + scrollerPhysicalHeight > scrollerHeight;
	
	      return pastTop || pastBottom;
	    };
	
	    _this.handleScroll = function () {
	      if (!_this.scrollTicking) {
	        _this.scrollTicking = true;
	        (0, _raf2.default)(_this.update);
	      }
	    };
	
	    _this.handleResize = function () {
	      if (!_this.resizeTicking) {
	        _this.resizeTicking = true;
	        (0, _raf2.default)(_this.setHeightOffset);
	      }
	    };
	
	    _this.unpin = function () {
	      _this.props.onUnpin();
	
	      _this.setState({
	        translateY: '-100%',
	        className: 'headroom headroom--unpinned'
	      }, function () {
	        setTimeout(function () {
	          _this.setState({ state: 'unpinned' });
	        }, 0);
	      });
	    };
	
	    _this.pin = function () {
	      _this.props.onPin();
	
	      _this.setState({
	        translateY: 0,
	        className: 'headroom headroom--pinned',
	        state: 'pinned'
	      });
	    };
	
	    _this.unfix = function () {
	      _this.props.onUnfix();
	
	      _this.setState({
	        translateY: 0,
	        className: 'headroom headroom--unfixed',
	        state: 'unfixed'
	      });
	    };
	
	    _this.update = function () {
	      _this.currentScrollY = _this.getScrollY();
	
	      if (!_this.isOutOfBound(_this.currentScrollY)) {
	        var _shouldUpdate = (0, _shouldUpdate3.default)(_this.lastKnownScrollY, _this.currentScrollY, _this.props, _this.state),
	            action = _shouldUpdate.action;
	
	        if (action === 'pin') {
	          _this.pin();
	        } else if (action === 'unpin') {
	          _this.unpin();
	        } else if (action === 'unfix') {
	          _this.unfix();
	        }
	      }
	
	      _this.lastKnownScrollY = _this.currentScrollY;
	      _this.scrollTicking = false;
	    };
	
	    _this.currentScrollY = 0;
	    _this.lastKnownScrollY = 0;
	    _this.scrollTicking = false;
	    _this.resizeTicking = false;
	    _this.state = {
	      state: 'unfixed',
	      translateY: 0,
	      className: 'headroom headroom--unfixed'
	    };
	    return _this;
	  }
	
	  _createClass(Headroom, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setHeightOffset();
	      if (!this.props.disable) {
	        this.props.parent().addEventListener('scroll', this.handleScroll);
	
	        if (this.props.calcHeightOnResize) {
	          this.props.parent().addEventListener('resize', this.handleResize);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disable && !this.props.disable) {
	        this.unfix();
	        this.props.parent().removeEventListener('scroll', this.handleScroll);
	        this.props.parent().removeEventListener('resize', this.handleResize);
	      } else if (!nextProps.disable && this.props.disable) {
	        this.props.parent().addEventListener('scroll', this.handleScroll);
	
	        if (this.props.calcHeightOnResize) {
	          this.props.parent().addEventListener('resize', this.handleResize);
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // If children have changed, remeasure height.
	      if (prevProps.children !== this.props.children) {
	        this.setHeightOffset();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.parent().removeEventListener('scroll', this.handleScroll);
	      window.removeEventListener('scroll', this.handleScroll);
	      this.props.parent().removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          userClassName = _props.className,
	          divProps = _objectWithoutProperties(_props, ['className']);
	
	      delete divProps.onUnpin;
	      delete divProps.onPin;
	      delete divProps.onUnfix;
	      delete divProps.disableInlineStyles;
	      delete divProps.disable;
	      delete divProps.parent;
	      delete divProps.children;
	      delete divProps.upTolerance;
	      delete divProps.downTolerance;
	      delete divProps.pinStart;
	      delete divProps.calcHeightOnResize;
	
	      var style = divProps.style,
	          wrapperStyle = divProps.wrapperStyle,
	          rest = _objectWithoutProperties(divProps, ['style', 'wrapperStyle']);
	
	      var innerStyle = {
	        position: this.props.disable || this.state.state === 'unfixed' ? 'relative' : 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        zIndex: 1,
	        WebkitTransform: 'translateY(' + this.state.translateY + ')',
	        MsTransform: 'translateY(' + this.state.translateY + ')',
	        transform: 'translateY(' + this.state.translateY + ')'
	      };
	
	      var className = this.state.className;
	
	      // Don't add css transitions until after we've done the initial
	      // negative transform when transitioning from 'unfixed' to 'unpinned'.
	      // If we don't do this, the header will flash into view temporarily
	      // while it transitions from 0 — -100%.
	      if (this.state.state !== 'unfixed') {
	        innerStyle = _extends({}, innerStyle, {
	          WebkitTransition: 'all .2s ease-in-out',
	          MozTransition: 'all .2s ease-in-out',
	          OTransition: 'all .2s ease-in-out',
	          transition: 'all .2s ease-in-out'
	        });
	        className += ' headroom--scrolled';
	      }
	
	      if (!this.props.disableInlineStyles) {
	        innerStyle = _extends({}, innerStyle, style);
	      } else {
	        innerStyle = style;
	      }
	
	      var wrapperStyles = _extends({}, wrapperStyle, {
	        height: this.state.height ? this.state.height : null
	      });
	
	      var wrapperClassName = userClassName ? userClassName + ' headroom-wrapper' : 'headroom-wrapper';
	
	      return _react2.default.createElement(
	        'div',
	        { style: wrapperStyles, className: wrapperClassName },
	        _react2.default.createElement(
	          'div',
	          _extends({
	            ref: this.setRef
	          }, rest, {
	            style: innerStyle,
	            className: className
	          }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Headroom;
	}(_react.Component);
	
	Headroom.propTypes = {
	  className: _propTypes2.default.string,
	  parent: _propTypes2.default.func,
	  children: _propTypes2.default.any.isRequired,
	  disableInlineStyles: _propTypes2.default.bool,
	  disable: _propTypes2.default.bool,
	  upTolerance: _propTypes2.default.number,
	  downTolerance: _propTypes2.default.number,
	  onPin: _propTypes2.default.func,
	  onUnpin: _propTypes2.default.func,
	  onUnfix: _propTypes2.default.func,
	  wrapperStyle: _propTypes2.default.object,
	  pinStart: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  calcHeightOnResize: _propTypes2.default.bool
	};
	Headroom.defaultProps = {
	  parent: function parent() {
	    return window;
	  },
	  disableInlineStyles: false,
	  disable: false,
	  upTolerance: 5,
	  downTolerance: 0,
	  onPin: noop,
	  onUnpin: noop,
	  onUnfix: noop,
	  wrapperStyle: {},
	  pinStart: 0,
	  calcHeightOnResize: true
	};
	exports.default = Headroom;

/***/ }),

/***/ 898:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var lastKnownScrollY = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
	  var currentScrollY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
	  var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	  var state = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
	
	  var scrollDirection = currentScrollY >= lastKnownScrollY ? 'down' : 'up';
	  var distanceScrolled = Math.abs(currentScrollY - lastKnownScrollY);
	
	  // We're disabled
	  if (props.disable) {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're at the top and not fixed yet.
	  } else if (currentScrollY <= props.pinStart && state.state !== 'unfixed') {
	    return {
	      action: 'unfix',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're unfixed and headed down. Carry on.
	  } else if (currentScrollY <= state.height && scrollDirection === 'down' && state.state === 'unfixed') {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're past the header and scrolling down.
	    // We transition to "unpinned" if necessary.
	  } else if (scrollDirection === 'down' && ['pinned', 'unfixed'].indexOf(state.state) >= 0 && currentScrollY > state.height + props.pinStart && distanceScrolled > props.downTolerance) {
	    return {
	      action: 'unpin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're scrolling up, we transition to "pinned"
	  } else if (scrollDirection === 'up' && distanceScrolled > props.upTolerance && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
	    return {
	      action: 'pin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're scrolling up, and inside the header.
	    // We transition to pin regardless of upTolerance
	  } else if (scrollDirection === 'up' && currentScrollY <= state.height && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
	    return {
	      action: 'pin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	  } else {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	  }
	};

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Helmet = __webpack_require__(92);
	
	var _ScrollMagicContext = __webpack_require__(419);
	
	var _ScrollMagicContext2 = _interopRequireDefault(_ScrollMagicContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = (_temp = _class = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  App.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        location = _props.location;
	
	    return _react2.default.createElement(
	      _ScrollMagicContext2.default,
	      { location: location },
	      _react2.default.createElement(_Helmet.BaseHelmet, { location: location }),
	      children
	    );
	  };
	
	  return App;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.any,
	  location: _propTypes2.default.object
	}, _temp);
	exports.default = App;
	module.exports = exports['default'];

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Footer;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(884);
	
	var _footer = __webpack_require__(878);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Footer() {
		return _react2.default.createElement(
			'footer',
			{ className: 'ft-wrapper' },
			_react2.default.createElement(
				'div',
				{ className: 'container footer' },
				_react2.default.createElement(
					'div',
					{ className: 'grid row' },
					_react2.default.createElement(
						'div',
						{ className: 'grid__item col-4--small col-sm-4' },
						_react2.default.createElement('img', { src: 'https://studiogritt.files.wordpress.com/2018/04/logod12x-e1524694319660.png', style: { width: '50px', paddingBottom: '20px' } }),
						_react2.default.createElement(
							'p',
							{ className: 'meta' },
							'#TheAnswerIsDesign'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'grid__item col-8--small col-sm-8' },
						_react2.default.createElement(
							'div',
							{ className: 'footer__copy' },
							_react2.default.createElement(
								'p',
								{ className: 'lead mb0' },
								'We collaborate with ambitious brands and people; we\u2019d love to build something great together.'
							),
							_react2.default.createElement(
								'p',
								{ className: 'lead fw-bold' },
								_react2.default.createElement(
									'a',
									{ href: 'mailto:hello@studiogritt.com', className: 'link-hover' },
									'hello@studiogritt.com'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'footer__contact-info grid row grid--mobile' },
							_react2.default.createElement(
								'div',
								{ className: 'grid__item col-lg-4 col-md-6 col-sm-12  col-6 col-3--large mb3 mb0--large' },
								_react2.default.createElement(
									'p',
									{ className: 'fw-bold' },
									'Office'
								),
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'a',
										{ href: 'https://www.google.co.in/maps/place/Studio+Gritt/@12.9405085,77.6233863,15z/data=!4m5!3m4!1s0x0:0x2bcdf90c0082a20d!8m2!3d12.9405085!4d77.6233863', target: '_blank', className: 'address link-hover no-underline' },
										'Bangalore  '
									),
									_react2.default.createElement(
										'span',
										{ style: { display: 'block', fontSize: '1.4rem' } },
										' 5th Floor, 439, 18th Main, Koramangala 6th Block'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'grid__item col-md-6 col-lg-4 col-sm-12 col-6 col-3--large mb3 mb0--large' },
								_react2.default.createElement(
									'p',
									{ className: 'fw-bold' },
									'Start a conversation'
								),
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'a',
										{ href: 'mailto:hello@studiogritt.com', className: 'link-hover' },
										'hello@studiogritt.com'
									)
								),
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'a',
										{ href: 'tel:+91 78297 60981', className: 'link-hover no-underline' },
										'+91 9480848582'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'grid__item col-md-6 col-lg-4 col-sm-12  col-6 col-3--large mb5 mb0--large' },
								_react2.default.createElement(
									'p',
									{ className: 'fw-bold' },
									'Social'
								),
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'a',
										{ href: 'https://www.facebook.com/studiogrittindia/', className: 'link-hover', target: '_blank', onclick: 'ga(\'send\', \'event\', \'exit-facebook\', \'click\', \'BASIC Facebook\', {\'NonInteraction\': 1});' },
										'Facebook'
									)
								),
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'a',
										{ href: 'https://www.instagram.com/studiogritt/', className: 'link-hover', target: '_blank', onclick: 'ga(\'send\', \'event\', \'exit-facebook\', \'click\', \'BASIC Instagram\', {\'NonInteraction\': 1});' },
										'Instagram'
									)
								)
							)
						)
					)
				)
			)
		);
	}
	module.exports = exports['default'];

/***/ }),

/***/ 878:
/***/ (function(module, exports) {

	module.exports = {"content":"Footer"}

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _Footer = __webpack_require__(373);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Footer2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 884:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(191);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A <Link /> is used an enhanced React Router Link. This Component
	 * will render a plain anchor tag when the Link is external. This
	 * Link will also prefetch anything in getComponent for a given route.
	 * This provides a smoother experience for the user.
	 *
	 */
	var Link = (_temp = _class = function (_Component) {
	  _inherits(Link, _Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        rest = _objectWithoutProperties(_props, ['children']);
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      rest,
	      children
	    );
	  };
	
	  return Link;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.node,
	  to: _propTypes2.default.string
	}, _temp);
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp2;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Hamburger = __webpack_require__(408);
	
	var _Hamburger2 = _interopRequireDefault(_Hamburger);
	
	var _reactHeadroom = __webpack_require__(897);
	
	var _reactHeadroom2 = _interopRequireDefault(_reactHeadroom);
	
	var _Link = __webpack_require__(41);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _stylesModule = __webpack_require__(696);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	__webpack_require__(886);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bar = (_temp2 = _class = function (_PureComponent) {
	  _inherits(Bar, _PureComponent);
	
	  function Bar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Bar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.settings = {
	      disableInlineStyles: true,
	      disable: true
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Bar.prototype.render = function render() {
	    var _props = this.props,
	        toggle = _props.toggle,
	        opened = _props.opened;
	
	    return _react2.default.createElement(
	      _reactHeadroom2.default,
	      this.settings,
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.container },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.left },
	          _react2.default.createElement(
	            _Link2.default,
	            { to: '/' },
	            _react2.default.createElement('img', { src: 'https://studiogritt.files.wordpress.com/2018/04/logod12x-1.png', alt: 'logo', style: { maxHeight: '100%', width: '110px', marginTop: '20px' } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.right },
	          _react2.default.createElement(_Hamburger2.default, { opened: opened, onClick: toggle })
	        )
	      )
	    );
	  };
	
	  return Bar;
	}(_react.PureComponent), _class.propTypes = {
	  opened: _propTypes2.default.bool,
	  toggle: _propTypes2.default.func
	}, _temp2);
	exports.default = Bar;
	module.exports = exports['default'];

/***/ }),

/***/ 886:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _Bar = __webpack_require__(405);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Bar2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 696:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container-fluid":"src-components-Nav-Bar----styles-module---container-fluid---12Gux","row":"src-components-Nav-Bar----styles-module---row---1SC9c","reverse":"src-components-Nav-Bar----styles-module---reverse---3J1-0","col":"src-components-Nav-Bar----styles-module---col---2-quJ","col-xs":"src-components-Nav-Bar----styles-module---col-xs---2Wonq","col-xs-1":"src-components-Nav-Bar----styles-module---col-xs-1---yfVSg","col-xs-2":"src-components-Nav-Bar----styles-module---col-xs-2---i76Ym","col-xs-3":"src-components-Nav-Bar----styles-module---col-xs-3---1ESfL","col-xs-4":"src-components-Nav-Bar----styles-module---col-xs-4---25zwP","col-xs-5":"src-components-Nav-Bar----styles-module---col-xs-5---3k-4v","col-xs-6":"src-components-Nav-Bar----styles-module---col-xs-6---1GIRT","col-xs-7":"src-components-Nav-Bar----styles-module---col-xs-7---2Zt8O","col-xs-8":"src-components-Nav-Bar----styles-module---col-xs-8---3MEvE","col-xs-9":"src-components-Nav-Bar----styles-module---col-xs-9---BLRUS","col-xs-10":"src-components-Nav-Bar----styles-module---col-xs-10---1L62S","col-xs-11":"src-components-Nav-Bar----styles-module---col-xs-11---243ZZ","col-xs-12":"src-components-Nav-Bar----styles-module---col-xs-12---2EqOt","col-xs-offset-1":"src-components-Nav-Bar----styles-module---col-xs-offset-1---2ZS9e","col-xs-offset-2":"src-components-Nav-Bar----styles-module---col-xs-offset-2---31PRA","col-xs-offset-3":"src-components-Nav-Bar----styles-module---col-xs-offset-3---bbmWm","col-xs-offset-4":"src-components-Nav-Bar----styles-module---col-xs-offset-4---3ZR9r","col-xs-offset-5":"src-components-Nav-Bar----styles-module---col-xs-offset-5---73KCQ","col-xs-offset-6":"src-components-Nav-Bar----styles-module---col-xs-offset-6---2xj0l","col-xs-offset-7":"src-components-Nav-Bar----styles-module---col-xs-offset-7---3udF2","col-xs-offset-8":"src-components-Nav-Bar----styles-module---col-xs-offset-8---1g1Kx","col-xs-offset-9":"src-components-Nav-Bar----styles-module---col-xs-offset-9---20i90","col-xs-offset-10":"src-components-Nav-Bar----styles-module---col-xs-offset-10---v5ZLy","col-xs-offset-11":"src-components-Nav-Bar----styles-module---col-xs-offset-11---3L5AA","start-xs":"src-components-Nav-Bar----styles-module---start-xs---2_GRS","center-xs":"src-components-Nav-Bar----styles-module---center-xs---3cL2r","end-xs":"src-components-Nav-Bar----styles-module---end-xs---3AWuo","top-xs":"src-components-Nav-Bar----styles-module---top-xs---YFyLY","middle-xs":"src-components-Nav-Bar----styles-module---middle-xs---W7f-D","bottom-xs":"src-components-Nav-Bar----styles-module---bottom-xs---1tbyr","around-xs":"src-components-Nav-Bar----styles-module---around-xs---H9vuw","between-xs":"src-components-Nav-Bar----styles-module---between-xs---2pmsr","first-xs":"src-components-Nav-Bar----styles-module---first-xs---1d6_k","last-xs":"src-components-Nav-Bar----styles-module---last-xs---3767Q","container":"src-components-Nav-Bar----styles-module---container---2yzmO","col-sm":"src-components-Nav-Bar----styles-module---col-sm---26om6","col-sm-1":"src-components-Nav-Bar----styles-module---col-sm-1---3OEhg","col-sm-2":"src-components-Nav-Bar----styles-module---col-sm-2---fZy8k","col-sm-3":"src-components-Nav-Bar----styles-module---col-sm-3---3xQUD","col-sm-4":"src-components-Nav-Bar----styles-module---col-sm-4---KdLEL","col-sm-5":"src-components-Nav-Bar----styles-module---col-sm-5---3QPTI","col-sm-6":"src-components-Nav-Bar----styles-module---col-sm-6---3PcDe","col-sm-7":"src-components-Nav-Bar----styles-module---col-sm-7---2AQbj","col-sm-8":"src-components-Nav-Bar----styles-module---col-sm-8---WcUax","col-sm-9":"src-components-Nav-Bar----styles-module---col-sm-9---3QKAN","col-sm-10":"src-components-Nav-Bar----styles-module---col-sm-10---L5fcy","col-sm-11":"src-components-Nav-Bar----styles-module---col-sm-11---3xnog","col-sm-12":"src-components-Nav-Bar----styles-module---col-sm-12---v4XxP","col-sm-offset-1":"src-components-Nav-Bar----styles-module---col-sm-offset-1---2t4SO","col-sm-offset-2":"src-components-Nav-Bar----styles-module---col-sm-offset-2---2RMR4","col-sm-offset-3":"src-components-Nav-Bar----styles-module---col-sm-offset-3---1qzvl","col-sm-offset-4":"src-components-Nav-Bar----styles-module---col-sm-offset-4---3pHPD","col-sm-offset-5":"src-components-Nav-Bar----styles-module---col-sm-offset-5---sYKJI","col-sm-offset-6":"src-components-Nav-Bar----styles-module---col-sm-offset-6---nk9oO","col-sm-offset-7":"src-components-Nav-Bar----styles-module---col-sm-offset-7---dILig","col-sm-offset-8":"src-components-Nav-Bar----styles-module---col-sm-offset-8---1Z4qM","col-sm-offset-9":"src-components-Nav-Bar----styles-module---col-sm-offset-9---1oZZ8","col-sm-offset-10":"src-components-Nav-Bar----styles-module---col-sm-offset-10---2OfqV","col-sm-offset-11":"src-components-Nav-Bar----styles-module---col-sm-offset-11---1kZNK","start-sm":"src-components-Nav-Bar----styles-module---start-sm---EMVje","center-sm":"src-components-Nav-Bar----styles-module---center-sm---3Rc1t","end-sm":"src-components-Nav-Bar----styles-module---end-sm---B2h45","top-sm":"src-components-Nav-Bar----styles-module---top-sm---XKu9s","middle-sm":"src-components-Nav-Bar----styles-module---middle-sm---2UCpv","bottom-sm":"src-components-Nav-Bar----styles-module---bottom-sm---3sSqV","around-sm":"src-components-Nav-Bar----styles-module---around-sm---3FepG","between-sm":"src-components-Nav-Bar----styles-module---between-sm---2RpfQ","first-sm":"src-components-Nav-Bar----styles-module---first-sm---28Coh","last-sm":"src-components-Nav-Bar----styles-module---last-sm---3ngbz","col-md":"src-components-Nav-Bar----styles-module---col-md---2Nylo","col-md-1":"src-components-Nav-Bar----styles-module---col-md-1---3bZOy","col-md-2":"src-components-Nav-Bar----styles-module---col-md-2---3MaiW","col-md-3":"src-components-Nav-Bar----styles-module---col-md-3---3ZbfH","col-md-4":"src-components-Nav-Bar----styles-module---col-md-4---3_lYi","col-md-5":"src-components-Nav-Bar----styles-module---col-md-5---2Atqg","col-md-6":"src-components-Nav-Bar----styles-module---col-md-6---3mjvw","col-md-7":"src-components-Nav-Bar----styles-module---col-md-7---jeHwJ","col-md-8":"src-components-Nav-Bar----styles-module---col-md-8---3ptK6","col-md-9":"src-components-Nav-Bar----styles-module---col-md-9---bNkUP","col-md-10":"src-components-Nav-Bar----styles-module---col-md-10---27Rqu","col-md-11":"src-components-Nav-Bar----styles-module---col-md-11---1OZb6","col-md-12":"src-components-Nav-Bar----styles-module---col-md-12---1A0Mv","col-md-offset-1":"src-components-Nav-Bar----styles-module---col-md-offset-1---1T1s0","col-md-offset-2":"src-components-Nav-Bar----styles-module---col-md-offset-2---3Pzlo","col-md-offset-3":"src-components-Nav-Bar----styles-module---col-md-offset-3---37RnD","col-md-offset-4":"src-components-Nav-Bar----styles-module---col-md-offset-4---2bvCd","col-md-offset-5":"src-components-Nav-Bar----styles-module---col-md-offset-5---qTzFR","col-md-offset-6":"src-components-Nav-Bar----styles-module---col-md-offset-6---2kSxJ","col-md-offset-7":"src-components-Nav-Bar----styles-module---col-md-offset-7---gAcHH","col-md-offset-8":"src-components-Nav-Bar----styles-module---col-md-offset-8---W3L_w","col-md-offset-9":"src-components-Nav-Bar----styles-module---col-md-offset-9---1g9ul","col-md-offset-10":"src-components-Nav-Bar----styles-module---col-md-offset-10---26TQK","col-md-offset-11":"src-components-Nav-Bar----styles-module---col-md-offset-11---3VEt5","start-md":"src-components-Nav-Bar----styles-module---start-md---229xK","center-md":"src-components-Nav-Bar----styles-module---center-md---3ShB5","end-md":"src-components-Nav-Bar----styles-module---end-md---3z58l","top-md":"src-components-Nav-Bar----styles-module---top-md---2YV1n","middle-md":"src-components-Nav-Bar----styles-module---middle-md---3S_wn","bottom-md":"src-components-Nav-Bar----styles-module---bottom-md---2BLr3","around-md":"src-components-Nav-Bar----styles-module---around-md---C7AsT","between-md":"src-components-Nav-Bar----styles-module---between-md---1GqsG","first-md":"src-components-Nav-Bar----styles-module---first-md---2Ac6K","last-md":"src-components-Nav-Bar----styles-module---last-md---2Cy2U","col-lg":"src-components-Nav-Bar----styles-module---col-lg---YniYo","col-lg-1":"src-components-Nav-Bar----styles-module---col-lg-1---2Pm8Z","col-lg-2":"src-components-Nav-Bar----styles-module---col-lg-2---jcvjS","col-lg-3":"src-components-Nav-Bar----styles-module---col-lg-3---3HHax","col-lg-4":"src-components-Nav-Bar----styles-module---col-lg-4---11ZxO","col-lg-5":"src-components-Nav-Bar----styles-module---col-lg-5---31V7k","col-lg-6":"src-components-Nav-Bar----styles-module---col-lg-6---2VF3G","col-lg-7":"src-components-Nav-Bar----styles-module---col-lg-7---3i9UE","col-lg-8":"src-components-Nav-Bar----styles-module---col-lg-8---37hD2","col-lg-9":"src-components-Nav-Bar----styles-module---col-lg-9---ZPLX0","col-lg-10":"src-components-Nav-Bar----styles-module---col-lg-10---3M7mY","col-lg-11":"src-components-Nav-Bar----styles-module---col-lg-11---2zTgb","col-lg-12":"src-components-Nav-Bar----styles-module---col-lg-12---3PJA_","col-lg-offset-1":"src-components-Nav-Bar----styles-module---col-lg-offset-1---1xhe5","col-lg-offset-2":"src-components-Nav-Bar----styles-module---col-lg-offset-2---2-Jiy","col-lg-offset-3":"src-components-Nav-Bar----styles-module---col-lg-offset-3---3HAWL","col-lg-offset-4":"src-components-Nav-Bar----styles-module---col-lg-offset-4---1ljQC","col-lg-offset-5":"src-components-Nav-Bar----styles-module---col-lg-offset-5---3zJK3","col-lg-offset-6":"src-components-Nav-Bar----styles-module---col-lg-offset-6---15Ogj","col-lg-offset-7":"src-components-Nav-Bar----styles-module---col-lg-offset-7---2UtoB","col-lg-offset-8":"src-components-Nav-Bar----styles-module---col-lg-offset-8---2CUyR","col-lg-offset-9":"src-components-Nav-Bar----styles-module---col-lg-offset-9---3rp5S","col-lg-offset-10":"src-components-Nav-Bar----styles-module---col-lg-offset-10---gqSvO","col-lg-offset-11":"src-components-Nav-Bar----styles-module---col-lg-offset-11---1dj8C","start-lg":"src-components-Nav-Bar----styles-module---start-lg---1ZkAU","center-lg":"src-components-Nav-Bar----styles-module---center-lg---1_UT3","end-lg":"src-components-Nav-Bar----styles-module---end-lg---1Svm7","top-lg":"src-components-Nav-Bar----styles-module---top-lg---3lqyp","middle-lg":"src-components-Nav-Bar----styles-module---middle-lg---MHhU2","bottom-lg":"src-components-Nav-Bar----styles-module---bottom-lg---rUVug","around-lg":"src-components-Nav-Bar----styles-module---around-lg---3HGzC","between-lg":"src-components-Nav-Bar----styles-module---between-lg---iRpkb","first-lg":"src-components-Nav-Bar----styles-module---first-lg---39ZHk","last-lg":"src-components-Nav-Bar----styles-module---last-lg---XliTY","menu-list":"src-components-Nav-Bar----styles-module---menu-list---26bfG","menu-link":"src-components-Nav-Bar----styles-module---menu-link---2EUtL","underLine-container":"src-components-Nav-Bar----styles-module---underLine-container---3T1kI","hero":"src-components-Nav-Bar----styles-module---hero---dq1wv","hero__content":"src-components-Nav-Bar----styles-module---hero__content---1OWrL","hero_title":"src-components-Nav-Bar----styles-module---hero_title---2lIbm","hero__list-line":"src-components-Nav-Bar----styles-module---hero__list-line---aGarr","hero__list":"src-components-Nav-Bar----styles-module---hero__list---1OQxg","hero__list-item":"src-components-Nav-Bar----styles-module---hero__list-item---3pGSQ","std-header__bg-wrap":"src-components-Nav-Bar----styles-module---std-header__bg-wrap---fSZW5","std-header__bg":"src-components-Nav-Bar----styles-module---std-header__bg---2ydUp","home--section-bar":"src-components-Nav-Bar----styles-module---home--section-bar---36TsH","home-recent--project":"src-components-Nav-Bar----styles-module---home-recent--project---BgN2I","home-recent--project--image":"src-components-Nav-Bar----styles-module---home-recent--project--image---2k3bP","home-recent--project--image--con":"src-components-Nav-Bar----styles-module---home-recent--project--image--con---3dq-i","home-recent--project--image--bg":"src-components-Nav-Bar----styles-module---home-recent--project--image--bg---h0I1d","home-recent--project--details-wrap":"src-components-Nav-Bar----styles-module---home-recent--project--details-wrap---KuA8h","home-recent--project--details--name":"src-components-Nav-Bar----styles-module---home-recent--project--details--name---1MdRF","home-recent--project--details--type":"src-components-Nav-Bar----styles-module---home-recent--project--details--type---1HhTC","home-recent--project--details--para":"src-components-Nav-Bar----styles-module---home-recent--project--details--para---3v_mW","cs-home-about--text":"src-components-Nav-Bar----styles-module---cs-home-about--text---3oKWE","cur-next-slide":"src-components-Nav-Bar----styles-module---cur-next-slide---1-tTz","right":"src-components-Nav-Bar----styles-module---right---3eZnM","left":"src-components-Nav-Bar----styles-module---left---3r5Ve"};

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _stylesModule = __webpack_require__(697);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hamburger = (_temp = _class = function (_PureComponent) {
	  _inherits(Hamburger, _PureComponent);
	
	  function Hamburger() {
	    _classCallCheck(this, Hamburger);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Hamburger.prototype.componentDidMount = function componentDidMount() {
	    var timing = 0.15;
	    this.animation = new TimelineMax({ paused: true }).fromTo(this.top, timing, { y: 0 }, { y: 6 }).fromTo(this.bottom, timing, { y: 0 }, { y: -6 }, 0).fromTo(this.middle, timing, { opacity: 1 }, { opacity: 0 }, 0).fromTo(this.top, timing, { rotation: 0 }, { rotation: 45 }, timing).fromTo(this.bottom, timing, { rotation: 0 }, { rotation: -45 }, timing);
	  };
	
	  Hamburger.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.opened !== this.props.opened) {
	      this.props.opened ? this.animation.play() : this.animation.reverse();
	    }
	  };
	
	  Hamburger.prototype.refName = function refName(name) {
	    var _this2 = this;
	
	    return function (c) {
	      _this2[name] = c;
	    };
	  };
	
	  Hamburger.prototype.render = function render() {
	    var onClick = this.props.onClick;
	
	    return _react2.default.createElement(
	      'button',
	      { className: _stylesModule2.default.container, onClick: onClick },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.burger },
	        _react2.default.createElement('span', { className: _stylesModule2.default.bar, ref: this.refName('top') }),
	        _react2.default.createElement('span', { className: _stylesModule2.default.bar, ref: this.refName('middle') }),
	        _react2.default.createElement('span', { className: _stylesModule2.default.bar, ref: this.refName('bottom') })
	      )
	    );
	  };
	
	  return Hamburger;
	}(_react.PureComponent), _class.propTypes = {
	  onClick: _propTypes2.default.func,
	  opened: _propTypes2.default.bool
	}, _temp);
	exports.default = Hamburger;
	module.exports = exports['default'];

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _Hamburger = __webpack_require__(407);
	
	var _Hamburger2 = _interopRequireDefault(_Hamburger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Hamburger2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 697:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container-fluid":"src-components-Nav-Hamburger----styles-module---container-fluid---zWS44","row":"src-components-Nav-Hamburger----styles-module---row---1_aWh","reverse":"src-components-Nav-Hamburger----styles-module---reverse---3wd9d","col":"src-components-Nav-Hamburger----styles-module---col---61wzS","col-xs":"src-components-Nav-Hamburger----styles-module---col-xs---D-e5k","col-xs-1":"src-components-Nav-Hamburger----styles-module---col-xs-1---2AJDM","col-xs-2":"src-components-Nav-Hamburger----styles-module---col-xs-2---102LN","col-xs-3":"src-components-Nav-Hamburger----styles-module---col-xs-3---EDIJz","col-xs-4":"src-components-Nav-Hamburger----styles-module---col-xs-4---16_DX","col-xs-5":"src-components-Nav-Hamburger----styles-module---col-xs-5---3zlvx","col-xs-6":"src-components-Nav-Hamburger----styles-module---col-xs-6---2w4De","col-xs-7":"src-components-Nav-Hamburger----styles-module---col-xs-7---20dFe","col-xs-8":"src-components-Nav-Hamburger----styles-module---col-xs-8---2EnQa","col-xs-9":"src-components-Nav-Hamburger----styles-module---col-xs-9---ijk2R","col-xs-10":"src-components-Nav-Hamburger----styles-module---col-xs-10---3ng5Q","col-xs-11":"src-components-Nav-Hamburger----styles-module---col-xs-11---3VDt5","col-xs-12":"src-components-Nav-Hamburger----styles-module---col-xs-12---3Tbr-","col-xs-offset-1":"src-components-Nav-Hamburger----styles-module---col-xs-offset-1---23jP-","col-xs-offset-2":"src-components-Nav-Hamburger----styles-module---col-xs-offset-2---K93qA","col-xs-offset-3":"src-components-Nav-Hamburger----styles-module---col-xs-offset-3---VEt3s","col-xs-offset-4":"src-components-Nav-Hamburger----styles-module---col-xs-offset-4---mjOgo","col-xs-offset-5":"src-components-Nav-Hamburger----styles-module---col-xs-offset-5---3uGM0","col-xs-offset-6":"src-components-Nav-Hamburger----styles-module---col-xs-offset-6---2Ty4E","col-xs-offset-7":"src-components-Nav-Hamburger----styles-module---col-xs-offset-7---1tTUM","col-xs-offset-8":"src-components-Nav-Hamburger----styles-module---col-xs-offset-8---34MNj","col-xs-offset-9":"src-components-Nav-Hamburger----styles-module---col-xs-offset-9---ChLLT","col-xs-offset-10":"src-components-Nav-Hamburger----styles-module---col-xs-offset-10---yE5Je","col-xs-offset-11":"src-components-Nav-Hamburger----styles-module---col-xs-offset-11---14ksA","start-xs":"src-components-Nav-Hamburger----styles-module---start-xs---3EEhE","center-xs":"src-components-Nav-Hamburger----styles-module---center-xs---1fXr2","end-xs":"src-components-Nav-Hamburger----styles-module---end-xs---2UYvE","top-xs":"src-components-Nav-Hamburger----styles-module---top-xs---3qitz","middle-xs":"src-components-Nav-Hamburger----styles-module---middle-xs---2QcgB","bottom-xs":"src-components-Nav-Hamburger----styles-module---bottom-xs---1kIbK","around-xs":"src-components-Nav-Hamburger----styles-module---around-xs---110ek","between-xs":"src-components-Nav-Hamburger----styles-module---between-xs---2bprl","first-xs":"src-components-Nav-Hamburger----styles-module---first-xs---1sfss","last-xs":"src-components-Nav-Hamburger----styles-module---last-xs---1skL7","container":"src-components-Nav-Hamburger----styles-module---container---jMCYD","col-sm":"src-components-Nav-Hamburger----styles-module---col-sm---1JvcP","col-sm-1":"src-components-Nav-Hamburger----styles-module---col-sm-1---3QW6d","col-sm-2":"src-components-Nav-Hamburger----styles-module---col-sm-2---snjQl","col-sm-3":"src-components-Nav-Hamburger----styles-module---col-sm-3---1g1GD","col-sm-4":"src-components-Nav-Hamburger----styles-module---col-sm-4---3rXmY","col-sm-5":"src-components-Nav-Hamburger----styles-module---col-sm-5---PpoWf","col-sm-6":"src-components-Nav-Hamburger----styles-module---col-sm-6---EuD9U","col-sm-7":"src-components-Nav-Hamburger----styles-module---col-sm-7---3hcRZ","col-sm-8":"src-components-Nav-Hamburger----styles-module---col-sm-8---1kGV1","col-sm-9":"src-components-Nav-Hamburger----styles-module---col-sm-9---3Bmfv","col-sm-10":"src-components-Nav-Hamburger----styles-module---col-sm-10---2VBet","col-sm-11":"src-components-Nav-Hamburger----styles-module---col-sm-11---ye2QX","col-sm-12":"src-components-Nav-Hamburger----styles-module---col-sm-12---37G1G","col-sm-offset-1":"src-components-Nav-Hamburger----styles-module---col-sm-offset-1---15GYE","col-sm-offset-2":"src-components-Nav-Hamburger----styles-module---col-sm-offset-2---9BDhu","col-sm-offset-3":"src-components-Nav-Hamburger----styles-module---col-sm-offset-3---ClzbH","col-sm-offset-4":"src-components-Nav-Hamburger----styles-module---col-sm-offset-4---3hkHm","col-sm-offset-5":"src-components-Nav-Hamburger----styles-module---col-sm-offset-5---248W7","col-sm-offset-6":"src-components-Nav-Hamburger----styles-module---col-sm-offset-6---3AFjG","col-sm-offset-7":"src-components-Nav-Hamburger----styles-module---col-sm-offset-7---11JxN","col-sm-offset-8":"src-components-Nav-Hamburger----styles-module---col-sm-offset-8---2MB5i","col-sm-offset-9":"src-components-Nav-Hamburger----styles-module---col-sm-offset-9---3cHBm","col-sm-offset-10":"src-components-Nav-Hamburger----styles-module---col-sm-offset-10---1yRXf","col-sm-offset-11":"src-components-Nav-Hamburger----styles-module---col-sm-offset-11---2Nqf0","start-sm":"src-components-Nav-Hamburger----styles-module---start-sm---2RoAB","center-sm":"src-components-Nav-Hamburger----styles-module---center-sm---392iJ","end-sm":"src-components-Nav-Hamburger----styles-module---end-sm---3UpPM","top-sm":"src-components-Nav-Hamburger----styles-module---top-sm---dr3B0","middle-sm":"src-components-Nav-Hamburger----styles-module---middle-sm---3sb38","bottom-sm":"src-components-Nav-Hamburger----styles-module---bottom-sm---2pDh5","around-sm":"src-components-Nav-Hamburger----styles-module---around-sm---3mOeU","between-sm":"src-components-Nav-Hamburger----styles-module---between-sm---217e4","first-sm":"src-components-Nav-Hamburger----styles-module---first-sm---1amjw","last-sm":"src-components-Nav-Hamburger----styles-module---last-sm---3XiCG","col-md":"src-components-Nav-Hamburger----styles-module---col-md----PFJq","col-md-1":"src-components-Nav-Hamburger----styles-module---col-md-1---2CvYY","col-md-2":"src-components-Nav-Hamburger----styles-module---col-md-2---12uKc","col-md-3":"src-components-Nav-Hamburger----styles-module---col-md-3---1ludX","col-md-4":"src-components-Nav-Hamburger----styles-module---col-md-4---1TQqe","col-md-5":"src-components-Nav-Hamburger----styles-module---col-md-5---1_ME0","col-md-6":"src-components-Nav-Hamburger----styles-module---col-md-6---1_AwE","col-md-7":"src-components-Nav-Hamburger----styles-module---col-md-7---3eEZ6","col-md-8":"src-components-Nav-Hamburger----styles-module---col-md-8---2YCO_","col-md-9":"src-components-Nav-Hamburger----styles-module---col-md-9---2iQ34","col-md-10":"src-components-Nav-Hamburger----styles-module---col-md-10---1w-xm","col-md-11":"src-components-Nav-Hamburger----styles-module---col-md-11---1_asz","col-md-12":"src-components-Nav-Hamburger----styles-module---col-md-12---vcTqL","col-md-offset-1":"src-components-Nav-Hamburger----styles-module---col-md-offset-1---Rv_jK","col-md-offset-2":"src-components-Nav-Hamburger----styles-module---col-md-offset-2---11dTX","col-md-offset-3":"src-components-Nav-Hamburger----styles-module---col-md-offset-3---qjEkl","col-md-offset-4":"src-components-Nav-Hamburger----styles-module---col-md-offset-4---3R4LE","col-md-offset-5":"src-components-Nav-Hamburger----styles-module---col-md-offset-5---ff6vN","col-md-offset-6":"src-components-Nav-Hamburger----styles-module---col-md-offset-6---3o-92","col-md-offset-7":"src-components-Nav-Hamburger----styles-module---col-md-offset-7---2UV0H","col-md-offset-8":"src-components-Nav-Hamburger----styles-module---col-md-offset-8---2ofgR","col-md-offset-9":"src-components-Nav-Hamburger----styles-module---col-md-offset-9---3Nx0j","col-md-offset-10":"src-components-Nav-Hamburger----styles-module---col-md-offset-10---2nQqE","col-md-offset-11":"src-components-Nav-Hamburger----styles-module---col-md-offset-11---2NzhK","start-md":"src-components-Nav-Hamburger----styles-module---start-md---KB96_","center-md":"src-components-Nav-Hamburger----styles-module---center-md---3xnHC","end-md":"src-components-Nav-Hamburger----styles-module---end-md---OhXTk","top-md":"src-components-Nav-Hamburger----styles-module---top-md---2bFa3","middle-md":"src-components-Nav-Hamburger----styles-module---middle-md---3JOQG","bottom-md":"src-components-Nav-Hamburger----styles-module---bottom-md---PyYda","around-md":"src-components-Nav-Hamburger----styles-module---around-md---7XFKT","between-md":"src-components-Nav-Hamburger----styles-module---between-md---32bmU","first-md":"src-components-Nav-Hamburger----styles-module---first-md---1wkkp","last-md":"src-components-Nav-Hamburger----styles-module---last-md---nZmAz","col-lg":"src-components-Nav-Hamburger----styles-module---col-lg---3boBu","col-lg-1":"src-components-Nav-Hamburger----styles-module---col-lg-1---1hAtB","col-lg-2":"src-components-Nav-Hamburger----styles-module---col-lg-2---198EO","col-lg-3":"src-components-Nav-Hamburger----styles-module---col-lg-3---1iZ88","col-lg-4":"src-components-Nav-Hamburger----styles-module---col-lg-4---uxxlA","col-lg-5":"src-components-Nav-Hamburger----styles-module---col-lg-5---DK4Zl","col-lg-6":"src-components-Nav-Hamburger----styles-module---col-lg-6---1FODI","col-lg-7":"src-components-Nav-Hamburger----styles-module---col-lg-7---1PTVe","col-lg-8":"src-components-Nav-Hamburger----styles-module---col-lg-8---19SgK","col-lg-9":"src-components-Nav-Hamburger----styles-module---col-lg-9---1Sm9_","col-lg-10":"src-components-Nav-Hamburger----styles-module---col-lg-10---C5RGh","col-lg-11":"src-components-Nav-Hamburger----styles-module---col-lg-11---2qwVs","col-lg-12":"src-components-Nav-Hamburger----styles-module---col-lg-12---Aft05","col-lg-offset-1":"src-components-Nav-Hamburger----styles-module---col-lg-offset-1---2NV6n","col-lg-offset-2":"src-components-Nav-Hamburger----styles-module---col-lg-offset-2---3yEuY","col-lg-offset-3":"src-components-Nav-Hamburger----styles-module---col-lg-offset-3---1Kk1p","col-lg-offset-4":"src-components-Nav-Hamburger----styles-module---col-lg-offset-4---8QG9B","col-lg-offset-5":"src-components-Nav-Hamburger----styles-module---col-lg-offset-5---4_-fB","col-lg-offset-6":"src-components-Nav-Hamburger----styles-module---col-lg-offset-6---3fhHC","col-lg-offset-7":"src-components-Nav-Hamburger----styles-module---col-lg-offset-7---2Cqol","col-lg-offset-8":"src-components-Nav-Hamburger----styles-module---col-lg-offset-8---XQVlp","col-lg-offset-9":"src-components-Nav-Hamburger----styles-module---col-lg-offset-9---2_KKv","col-lg-offset-10":"src-components-Nav-Hamburger----styles-module---col-lg-offset-10---1Uf0z","col-lg-offset-11":"src-components-Nav-Hamburger----styles-module---col-lg-offset-11---2oZky","start-lg":"src-components-Nav-Hamburger----styles-module---start-lg---2Df3I","center-lg":"src-components-Nav-Hamburger----styles-module---center-lg---3ZJGX","end-lg":"src-components-Nav-Hamburger----styles-module---end-lg---3qEW3","top-lg":"src-components-Nav-Hamburger----styles-module---top-lg---q3rdT","middle-lg":"src-components-Nav-Hamburger----styles-module---middle-lg---18JwT","bottom-lg":"src-components-Nav-Hamburger----styles-module---bottom-lg---2YaQQ","around-lg":"src-components-Nav-Hamburger----styles-module---around-lg---1958O","between-lg":"src-components-Nav-Hamburger----styles-module---between-lg---1PoNG","first-lg":"src-components-Nav-Hamburger----styles-module---first-lg---IoSG6","last-lg":"src-components-Nav-Hamburger----styles-module---last-lg---16Vpz","menu-list":"src-components-Nav-Hamburger----styles-module---menu-list---3g5c0","menu-link":"src-components-Nav-Hamburger----styles-module---menu-link---1FvWS","underLine-container":"src-components-Nav-Hamburger----styles-module---underLine-container---2E30c","hero":"src-components-Nav-Hamburger----styles-module---hero---iZ2HT","hero__content":"src-components-Nav-Hamburger----styles-module---hero__content---wPWz4","hero_title":"src-components-Nav-Hamburger----styles-module---hero_title---lAZoQ","hero__list-line":"src-components-Nav-Hamburger----styles-module---hero__list-line---1yjYU","hero__list":"src-components-Nav-Hamburger----styles-module---hero__list---3U8aL","hero__list-item":"src-components-Nav-Hamburger----styles-module---hero__list-item---2Zewc","std-header__bg-wrap":"src-components-Nav-Hamburger----styles-module---std-header__bg-wrap---zFZkS","std-header__bg":"src-components-Nav-Hamburger----styles-module---std-header__bg---2F1d0","home--section-bar":"src-components-Nav-Hamburger----styles-module---home--section-bar---27-j6","home-recent--project":"src-components-Nav-Hamburger----styles-module---home-recent--project---6k1il","home-recent--project--image":"src-components-Nav-Hamburger----styles-module---home-recent--project--image---sOOuV","home-recent--project--image--con":"src-components-Nav-Hamburger----styles-module---home-recent--project--image--con---360Zn","home-recent--project--image--bg":"src-components-Nav-Hamburger----styles-module---home-recent--project--image--bg---2Jqa2","home-recent--project--details-wrap":"src-components-Nav-Hamburger----styles-module---home-recent--project--details-wrap---18E5J","home-recent--project--details--name":"src-components-Nav-Hamburger----styles-module---home-recent--project--details--name---1xpW-","home-recent--project--details--type":"src-components-Nav-Hamburger----styles-module---home-recent--project--details--type---15NLN","home-recent--project--details--para":"src-components-Nav-Hamburger----styles-module---home-recent--project--details--para---2f7oA","cs-home-about--text":"src-components-Nav-Hamburger----styles-module---cs-home-about--text---2RexQ","cur-next-slide":"src-components-Nav-Hamburger----styles-module---cur-next-slide---3zruc","text":"src-components-Nav-Hamburger----styles-module---text---TLH7S","burger":"src-components-Nav-Hamburger----styles-module---burger---1nyLp","bar":"src-components-Nav-Hamburger----styles-module---bar---c_-KI"};

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp2;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Link = __webpack_require__(41);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _stylesModule = __webpack_require__(698);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menu = (_temp2 = _class = function (_PureComponent) {
	  _inherits(Menu, _PureComponent);
	
	  function Menu() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Menu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.links = [], _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Menu.prototype.componentDidMount = function componentDidMount() {
	    this.createAnimation();
	  };
	
	  Menu.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.opened !== this.props.opened) {
	      this.props.opened ? this.open() : this.close();
	    }
	  };
	
	  Menu.prototype.createAnimation = function createAnimation() {
	    if (this.animaton) this.animaton.kill();
	    this.links = this.list.children;
	    this.animaton = new TimelineMax({ paused: true }).fromTo(this.menu, 0.25, { x: '100%' }, { x: '0%' }).staggerFromTo(this.links, 0.25, { opacity: 0 }, { opacity: 1, ease: Power2.easeIn }, 0.15);
	  };
	
	  Menu.prototype.open = function open() {
	    this.animaton.timeScale(1).play();
	  };
	
	  Menu.prototype.close = function close() {
	    this.animaton.timeScale(3).reverse();
	  };
	
	  Menu.prototype.refName = function refName(name) {
	    var _this2 = this;
	
	    return function (c) {
	      _this2[name] = c;
	    };
	  };
	
	  Menu.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.container, ref: this.refName('menu') },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.content },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.list, ref: this.refName('list') },
	          children.map(function (item, index) {
	            return _react2.default.createElement(
	              _Link2.default,
	              { key: index, className: _stylesModule2.default.link, to: item.to },
	              item.text
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return Menu;
	}(_react.PureComponent), _class.propTypes = {
	  children: _propTypes2.default.array,
	  opened: _propTypes2.default.bool
	}, _temp2);
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _Menu = __webpack_require__(409);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Menu2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container-fluid":"src-components-Nav-Menu----styles-module---container-fluid---1CydG","row":"src-components-Nav-Menu----styles-module---row---2pPws","reverse":"src-components-Nav-Menu----styles-module---reverse---3CikK","col":"src-components-Nav-Menu----styles-module---col---1MPmG","col-xs":"src-components-Nav-Menu----styles-module---col-xs---2bUM9","col-xs-1":"src-components-Nav-Menu----styles-module---col-xs-1---3NvsC","col-xs-2":"src-components-Nav-Menu----styles-module---col-xs-2---3D6e4","col-xs-3":"src-components-Nav-Menu----styles-module---col-xs-3---Vd2UB","col-xs-4":"src-components-Nav-Menu----styles-module---col-xs-4---2Xt8R","col-xs-5":"src-components-Nav-Menu----styles-module---col-xs-5---YLY3n","col-xs-6":"src-components-Nav-Menu----styles-module---col-xs-6---2YU-X","col-xs-7":"src-components-Nav-Menu----styles-module---col-xs-7---1yBrg","col-xs-8":"src-components-Nav-Menu----styles-module---col-xs-8---zFetn","col-xs-9":"src-components-Nav-Menu----styles-module---col-xs-9---3UyvI","col-xs-10":"src-components-Nav-Menu----styles-module---col-xs-10---2Ee1D","col-xs-11":"src-components-Nav-Menu----styles-module---col-xs-11---Gidcq","col-xs-12":"src-components-Nav-Menu----styles-module---col-xs-12---3_Mmw","col-xs-offset-1":"src-components-Nav-Menu----styles-module---col-xs-offset-1---1m14X","col-xs-offset-2":"src-components-Nav-Menu----styles-module---col-xs-offset-2---31kS4","col-xs-offset-3":"src-components-Nav-Menu----styles-module---col-xs-offset-3---LEwvq","col-xs-offset-4":"src-components-Nav-Menu----styles-module---col-xs-offset-4---29kuF","col-xs-offset-5":"src-components-Nav-Menu----styles-module---col-xs-offset-5---3uJWK","col-xs-offset-6":"src-components-Nav-Menu----styles-module---col-xs-offset-6---1ZPtj","col-xs-offset-7":"src-components-Nav-Menu----styles-module---col-xs-offset-7---1Gze0","col-xs-offset-8":"src-components-Nav-Menu----styles-module---col-xs-offset-8---2VAi4","col-xs-offset-9":"src-components-Nav-Menu----styles-module---col-xs-offset-9---2gKqZ","col-xs-offset-10":"src-components-Nav-Menu----styles-module---col-xs-offset-10---eaLjD","col-xs-offset-11":"src-components-Nav-Menu----styles-module---col-xs-offset-11---3Bp-P","start-xs":"src-components-Nav-Menu----styles-module---start-xs---1ebhR","center-xs":"src-components-Nav-Menu----styles-module---center-xs---3XjH4","end-xs":"src-components-Nav-Menu----styles-module---end-xs---1tLIO","top-xs":"src-components-Nav-Menu----styles-module---top-xs---svP5s","middle-xs":"src-components-Nav-Menu----styles-module---middle-xs---3yUk0","bottom-xs":"src-components-Nav-Menu----styles-module---bottom-xs---33eq0","around-xs":"src-components-Nav-Menu----styles-module---around-xs---FvaFz","between-xs":"src-components-Nav-Menu----styles-module---between-xs---v97Uz","first-xs":"src-components-Nav-Menu----styles-module---first-xs---DPwN6","last-xs":"src-components-Nav-Menu----styles-module---last-xs---38OQp","container":"src-components-Nav-Menu----styles-module---container---Yg4pU","col-sm":"src-components-Nav-Menu----styles-module---col-sm---OAvIl","col-sm-1":"src-components-Nav-Menu----styles-module---col-sm-1---2C35i","col-sm-2":"src-components-Nav-Menu----styles-module---col-sm-2---2JBEJ","col-sm-3":"src-components-Nav-Menu----styles-module---col-sm-3---W-_8J","col-sm-4":"src-components-Nav-Menu----styles-module---col-sm-4---2InYv","col-sm-5":"src-components-Nav-Menu----styles-module---col-sm-5---3XbJa","col-sm-6":"src-components-Nav-Menu----styles-module---col-sm-6---1YgZU","col-sm-7":"src-components-Nav-Menu----styles-module---col-sm-7---188BB","col-sm-8":"src-components-Nav-Menu----styles-module---col-sm-8---1iNve","col-sm-9":"src-components-Nav-Menu----styles-module---col-sm-9---1dSMn","col-sm-10":"src-components-Nav-Menu----styles-module---col-sm-10---3o0VA","col-sm-11":"src-components-Nav-Menu----styles-module---col-sm-11---2-Ycs","col-sm-12":"src-components-Nav-Menu----styles-module---col-sm-12---3kpRG","col-sm-offset-1":"src-components-Nav-Menu----styles-module---col-sm-offset-1---3zNeL","col-sm-offset-2":"src-components-Nav-Menu----styles-module---col-sm-offset-2---1GGaf","col-sm-offset-3":"src-components-Nav-Menu----styles-module---col-sm-offset-3---r3iVh","col-sm-offset-4":"src-components-Nav-Menu----styles-module---col-sm-offset-4---3clSP","col-sm-offset-5":"src-components-Nav-Menu----styles-module---col-sm-offset-5---CptAM","col-sm-offset-6":"src-components-Nav-Menu----styles-module---col-sm-offset-6---bhfin","col-sm-offset-7":"src-components-Nav-Menu----styles-module---col-sm-offset-7---2-dGx","col-sm-offset-8":"src-components-Nav-Menu----styles-module---col-sm-offset-8----Cwbo","col-sm-offset-9":"src-components-Nav-Menu----styles-module---col-sm-offset-9---2VYjb","col-sm-offset-10":"src-components-Nav-Menu----styles-module---col-sm-offset-10---2YtI7","col-sm-offset-11":"src-components-Nav-Menu----styles-module---col-sm-offset-11---2LD6e","start-sm":"src-components-Nav-Menu----styles-module---start-sm---2vRz6","center-sm":"src-components-Nav-Menu----styles-module---center-sm---1Dqxd","end-sm":"src-components-Nav-Menu----styles-module---end-sm---3VU3D","top-sm":"src-components-Nav-Menu----styles-module---top-sm---1m1lb","middle-sm":"src-components-Nav-Menu----styles-module---middle-sm---1fvpQ","bottom-sm":"src-components-Nav-Menu----styles-module---bottom-sm---1Lqtq","around-sm":"src-components-Nav-Menu----styles-module---around-sm---2iaCA","between-sm":"src-components-Nav-Menu----styles-module---between-sm---27EHe","first-sm":"src-components-Nav-Menu----styles-module---first-sm---28F_8","last-sm":"src-components-Nav-Menu----styles-module---last-sm---2C6a6","col-md":"src-components-Nav-Menu----styles-module---col-md---1BU_C","col-md-1":"src-components-Nav-Menu----styles-module---col-md-1---1-K6I","col-md-2":"src-components-Nav-Menu----styles-module---col-md-2---20cbm","col-md-3":"src-components-Nav-Menu----styles-module---col-md-3---2NLEc","col-md-4":"src-components-Nav-Menu----styles-module---col-md-4---2RbIz","col-md-5":"src-components-Nav-Menu----styles-module---col-md-5---2WGB8","col-md-6":"src-components-Nav-Menu----styles-module---col-md-6---AKnM8","col-md-7":"src-components-Nav-Menu----styles-module---col-md-7---1iC99","col-md-8":"src-components-Nav-Menu----styles-module---col-md-8---3fA_d","col-md-9":"src-components-Nav-Menu----styles-module---col-md-9---3u84l","col-md-10":"src-components-Nav-Menu----styles-module---col-md-10---2AFl7","col-md-11":"src-components-Nav-Menu----styles-module---col-md-11---D-79y","col-md-12":"src-components-Nav-Menu----styles-module---col-md-12---1U69m","col-md-offset-1":"src-components-Nav-Menu----styles-module---col-md-offset-1---3hKTY","col-md-offset-2":"src-components-Nav-Menu----styles-module---col-md-offset-2---2pNKE","col-md-offset-3":"src-components-Nav-Menu----styles-module---col-md-offset-3---3_DgV","col-md-offset-4":"src-components-Nav-Menu----styles-module---col-md-offset-4---242Ef","col-md-offset-5":"src-components-Nav-Menu----styles-module---col-md-offset-5---3_3Eg","col-md-offset-6":"src-components-Nav-Menu----styles-module---col-md-offset-6---3XePC","col-md-offset-7":"src-components-Nav-Menu----styles-module---col-md-offset-7---RTqJl","col-md-offset-8":"src-components-Nav-Menu----styles-module---col-md-offset-8---2vAH5","col-md-offset-9":"src-components-Nav-Menu----styles-module---col-md-offset-9---3zWT8","col-md-offset-10":"src-components-Nav-Menu----styles-module---col-md-offset-10---U5fG9","col-md-offset-11":"src-components-Nav-Menu----styles-module---col-md-offset-11---1E4dK","start-md":"src-components-Nav-Menu----styles-module---start-md---3gmXH","center-md":"src-components-Nav-Menu----styles-module---center-md---291eD","end-md":"src-components-Nav-Menu----styles-module---end-md---1YEuw","top-md":"src-components-Nav-Menu----styles-module---top-md---1CYlv","middle-md":"src-components-Nav-Menu----styles-module---middle-md---2GtDm","bottom-md":"src-components-Nav-Menu----styles-module---bottom-md---1B_Aq","around-md":"src-components-Nav-Menu----styles-module---around-md---2TsYk","between-md":"src-components-Nav-Menu----styles-module---between-md---26Xmi","first-md":"src-components-Nav-Menu----styles-module---first-md---5w89t","last-md":"src-components-Nav-Menu----styles-module---last-md---vxb5_","col-lg":"src-components-Nav-Menu----styles-module---col-lg---1oj8d","col-lg-1":"src-components-Nav-Menu----styles-module---col-lg-1---3FKsE","col-lg-2":"src-components-Nav-Menu----styles-module---col-lg-2---2LQG2","col-lg-3":"src-components-Nav-Menu----styles-module---col-lg-3---3Okpw","col-lg-4":"src-components-Nav-Menu----styles-module---col-lg-4---3VW7r","col-lg-5":"src-components-Nav-Menu----styles-module---col-lg-5---ol0nm","col-lg-6":"src-components-Nav-Menu----styles-module---col-lg-6---DiDKv","col-lg-7":"src-components-Nav-Menu----styles-module---col-lg-7---2yXUz","col-lg-8":"src-components-Nav-Menu----styles-module---col-lg-8---H3S18","col-lg-9":"src-components-Nav-Menu----styles-module---col-lg-9---13lEX","col-lg-10":"src-components-Nav-Menu----styles-module---col-lg-10---3mhBC","col-lg-11":"src-components-Nav-Menu----styles-module---col-lg-11---b3Ayl","col-lg-12":"src-components-Nav-Menu----styles-module---col-lg-12---1xkY-","col-lg-offset-1":"src-components-Nav-Menu----styles-module---col-lg-offset-1---36PF2","col-lg-offset-2":"src-components-Nav-Menu----styles-module---col-lg-offset-2---1bkOZ","col-lg-offset-3":"src-components-Nav-Menu----styles-module---col-lg-offset-3---3JH44","col-lg-offset-4":"src-components-Nav-Menu----styles-module---col-lg-offset-4---6-Wf4","col-lg-offset-5":"src-components-Nav-Menu----styles-module---col-lg-offset-5---mHTzc","col-lg-offset-6":"src-components-Nav-Menu----styles-module---col-lg-offset-6---3N47V","col-lg-offset-7":"src-components-Nav-Menu----styles-module---col-lg-offset-7---3djwU","col-lg-offset-8":"src-components-Nav-Menu----styles-module---col-lg-offset-8---2A-3W","col-lg-offset-9":"src-components-Nav-Menu----styles-module---col-lg-offset-9---2Xsgh","col-lg-offset-10":"src-components-Nav-Menu----styles-module---col-lg-offset-10---33WJl","col-lg-offset-11":"src-components-Nav-Menu----styles-module---col-lg-offset-11---CrtnR","start-lg":"src-components-Nav-Menu----styles-module---start-lg---3NkAb","center-lg":"src-components-Nav-Menu----styles-module---center-lg---1MQqI","end-lg":"src-components-Nav-Menu----styles-module---end-lg---1Gkaa","top-lg":"src-components-Nav-Menu----styles-module---top-lg---1HaPU","middle-lg":"src-components-Nav-Menu----styles-module---middle-lg---3lnA4","bottom-lg":"src-components-Nav-Menu----styles-module---bottom-lg---219Ss","around-lg":"src-components-Nav-Menu----styles-module---around-lg---1rZGQ","between-lg":"src-components-Nav-Menu----styles-module---between-lg---3wyZB","first-lg":"src-components-Nav-Menu----styles-module---first-lg---2262P","last-lg":"src-components-Nav-Menu----styles-module---last-lg---3Vi-o","menu-list":"src-components-Nav-Menu----styles-module---menu-list---33nof","menu-link":"src-components-Nav-Menu----styles-module---menu-link---Cnbg5","underLine-container":"src-components-Nav-Menu----styles-module---underLine-container---2WeUv","hero":"src-components-Nav-Menu----styles-module---hero---1t9n_","hero__content":"src-components-Nav-Menu----styles-module---hero__content---3Wd8A","hero_title":"src-components-Nav-Menu----styles-module---hero_title---1OLyQ","hero__list-line":"src-components-Nav-Menu----styles-module---hero__list-line---1VnDO","hero__list":"src-components-Nav-Menu----styles-module---hero__list---1ktrD","hero__list-item":"src-components-Nav-Menu----styles-module---hero__list-item---e0v8K","std-header__bg-wrap":"src-components-Nav-Menu----styles-module---std-header__bg-wrap---2hXom","std-header__bg":"src-components-Nav-Menu----styles-module---std-header__bg---1ZYTc","home--section-bar":"src-components-Nav-Menu----styles-module---home--section-bar---1pWLU","home-recent--project":"src-components-Nav-Menu----styles-module---home-recent--project---3ScFv","home-recent--project--image":"src-components-Nav-Menu----styles-module---home-recent--project--image---2M7ol","home-recent--project--image--con":"src-components-Nav-Menu----styles-module---home-recent--project--image--con---2PhtG","home-recent--project--image--bg":"src-components-Nav-Menu----styles-module---home-recent--project--image--bg---12dDI","home-recent--project--details-wrap":"src-components-Nav-Menu----styles-module---home-recent--project--details-wrap---2cXAZ","home-recent--project--details--name":"src-components-Nav-Menu----styles-module---home-recent--project--details--name---2rb7g","home-recent--project--details--type":"src-components-Nav-Menu----styles-module---home-recent--project--details--type---1TkRy","home-recent--project--details--para":"src-components-Nav-Menu----styles-module---home-recent--project--details--para---1u6dd","cs-home-about--text":"src-components-Nav-Menu----styles-module---cs-home-about--text---1RWAk","cur-next-slide":"src-components-Nav-Menu----styles-module---cur-next-slide---1Iik5","content":"src-components-Nav-Menu----styles-module---content---1usZo","list":"src-components-Nav-Menu----styles-module---list---2Hd8z","link":"src-components-Nav-Menu----styles-module---link---2Y8Zx"};

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp2;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Bar = __webpack_require__(406);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _Menu = __webpack_require__(410);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _stylesModule = __webpack_require__(699);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _nav = __webpack_require__(879);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nav = (_temp2 = _class = function (_Component) {
	  _inherits(Nav, _Component);
	
	  function Nav() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Nav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onScroll = function (event) {
	      if (_this.props.opened) {
	        event.preventDefault();
	        return false;
	      }
	    }, _this.toggle = function () {
	      _this.props.toggle();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Nav.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.opened) this.props.close();
	    window.addEventListener('wheel', this.onScroll);
	    window.addEventListener('touchmove', this.onScroll);
	  };
	
	  Nav.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('wheel', this.onScroll);
	    window.removeEventListener('touchmove', this.onScroll);
	  };
	
	  Nav.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.location !== nextProps.location) {
	      this.props.close();
	    }
	  };
	
	  Nav.prototype.render = function render() {
	    return _react2.default.createElement(
	      'nav',
	      { className: _stylesModule2.default.nav },
	      _react2.default.createElement(_Bar2.default, { opened: this.props.opened, toggle: this.toggle }),
	      _react2.default.createElement(
	        _Menu2.default,
	        { opened: this.props.opened },
	        _nav2.default.nav.links
	      )
	    );
	  };
	
	  return Nav;
	}(_react.Component), _class.propTypes = {
	  location: _propTypes2.default.object,
	  opened: _propTypes2.default.bool,
	  toggle: _propTypes2.default.func,
	  close: _propTypes2.default.func
	}, _temp2);
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Nav = __webpack_require__(411);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _reactRedux = __webpack_require__(40);
	
	var _nav = __webpack_require__(279);
	
	var Actions = _interopRequireWildcard(_nav);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(_ref) {
	  var nav = _ref.nav;
	
	  return {
	    opened: nav.opened
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    toggle: function toggle() {
	      return dispatch(Actions.toggle());
	    },
	    close: function close() {
	      return dispatch(Actions.close());
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Nav2.default);
	module.exports = exports['default'];

/***/ }),

/***/ 879:
/***/ (function(module, exports) {

	module.exports = {"nav":{"links":[{"text":"Home","to":"/"},{"text":"About","to":"/about"},{"text":"Architecture","to":"/architecture"},{"text":"Interiors","to":"/interiors"},{"text":"Products","to":"/products"},{"text":"Blogs","to":"/blogs"}]}}

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container-fluid":"src-components-Nav----styles-module---container-fluid---15MxJ","row":"src-components-Nav----styles-module---row---3cSws","reverse":"src-components-Nav----styles-module---reverse---2RMlJ","col":"src-components-Nav----styles-module---col---2_RUd","col-xs":"src-components-Nav----styles-module---col-xs---2-XJi","col-xs-1":"src-components-Nav----styles-module---col-xs-1---3T2bp","col-xs-2":"src-components-Nav----styles-module---col-xs-2---15eAP","col-xs-3":"src-components-Nav----styles-module---col-xs-3---XVDwb","col-xs-4":"src-components-Nav----styles-module---col-xs-4---1NnWb","col-xs-5":"src-components-Nav----styles-module---col-xs-5---3fIVZ","col-xs-6":"src-components-Nav----styles-module---col-xs-6---3zEna","col-xs-7":"src-components-Nav----styles-module---col-xs-7---TJ5-X","col-xs-8":"src-components-Nav----styles-module---col-xs-8---EvQrX","col-xs-9":"src-components-Nav----styles-module---col-xs-9---3ghk6","col-xs-10":"src-components-Nav----styles-module---col-xs-10---qgLC0","col-xs-11":"src-components-Nav----styles-module---col-xs-11---3ePhD","col-xs-12":"src-components-Nav----styles-module---col-xs-12---2uuxG","col-xs-offset-1":"src-components-Nav----styles-module---col-xs-offset-1---1czEM","col-xs-offset-2":"src-components-Nav----styles-module---col-xs-offset-2---18JsS","col-xs-offset-3":"src-components-Nav----styles-module---col-xs-offset-3---m0ack","col-xs-offset-4":"src-components-Nav----styles-module---col-xs-offset-4---1Qz0U","col-xs-offset-5":"src-components-Nav----styles-module---col-xs-offset-5---1ju60","col-xs-offset-6":"src-components-Nav----styles-module---col-xs-offset-6---143M3","col-xs-offset-7":"src-components-Nav----styles-module---col-xs-offset-7---1Bz-u","col-xs-offset-8":"src-components-Nav----styles-module---col-xs-offset-8---19yru","col-xs-offset-9":"src-components-Nav----styles-module---col-xs-offset-9---2HXJO","col-xs-offset-10":"src-components-Nav----styles-module---col-xs-offset-10---3nadW","col-xs-offset-11":"src-components-Nav----styles-module---col-xs-offset-11---Y64p3","start-xs":"src-components-Nav----styles-module---start-xs---mcSUA","center-xs":"src-components-Nav----styles-module---center-xs---1BEKa","end-xs":"src-components-Nav----styles-module---end-xs---3Vw7x","top-xs":"src-components-Nav----styles-module---top-xs---gXU9i","middle-xs":"src-components-Nav----styles-module---middle-xs---2JpQP","bottom-xs":"src-components-Nav----styles-module---bottom-xs---FYz43","around-xs":"src-components-Nav----styles-module---around-xs---2mAL_","between-xs":"src-components-Nav----styles-module---between-xs---361Q3","first-xs":"src-components-Nav----styles-module---first-xs---1pZII","last-xs":"src-components-Nav----styles-module---last-xs---5Mrq0","container":"src-components-Nav----styles-module---container---3mDry","col-sm":"src-components-Nav----styles-module---col-sm---3f3M3","col-sm-1":"src-components-Nav----styles-module---col-sm-1---2bOU7","col-sm-2":"src-components-Nav----styles-module---col-sm-2---2Df2i","col-sm-3":"src-components-Nav----styles-module---col-sm-3---25CG3","col-sm-4":"src-components-Nav----styles-module---col-sm-4---XW3X8","col-sm-5":"src-components-Nav----styles-module---col-sm-5---2yHpI","col-sm-6":"src-components-Nav----styles-module---col-sm-6---20Lzm","col-sm-7":"src-components-Nav----styles-module---col-sm-7---2oG36","col-sm-8":"src-components-Nav----styles-module---col-sm-8---3fzlC","col-sm-9":"src-components-Nav----styles-module---col-sm-9---HSMWR","col-sm-10":"src-components-Nav----styles-module---col-sm-10---1Lj39","col-sm-11":"src-components-Nav----styles-module---col-sm-11---2Vrwz","col-sm-12":"src-components-Nav----styles-module---col-sm-12---36K5I","col-sm-offset-1":"src-components-Nav----styles-module---col-sm-offset-1---121cK","col-sm-offset-2":"src-components-Nav----styles-module---col-sm-offset-2---2y_bs","col-sm-offset-3":"src-components-Nav----styles-module---col-sm-offset-3---2Sxp4","col-sm-offset-4":"src-components-Nav----styles-module---col-sm-offset-4---t6UGT","col-sm-offset-5":"src-components-Nav----styles-module---col-sm-offset-5---2PdI2","col-sm-offset-6":"src-components-Nav----styles-module---col-sm-offset-6---3rzTz","col-sm-offset-7":"src-components-Nav----styles-module---col-sm-offset-7---3mhrX","col-sm-offset-8":"src-components-Nav----styles-module---col-sm-offset-8---3Cawe","col-sm-offset-9":"src-components-Nav----styles-module---col-sm-offset-9---31fBQ","col-sm-offset-10":"src-components-Nav----styles-module---col-sm-offset-10---3HCFj","col-sm-offset-11":"src-components-Nav----styles-module---col-sm-offset-11---3Tk6w","start-sm":"src-components-Nav----styles-module---start-sm---3O6_j","center-sm":"src-components-Nav----styles-module---center-sm---OQn1t","end-sm":"src-components-Nav----styles-module---end-sm---3yBpD","top-sm":"src-components-Nav----styles-module---top-sm---g-wwj","middle-sm":"src-components-Nav----styles-module---middle-sm---kHJnG","bottom-sm":"src-components-Nav----styles-module---bottom-sm---3tlFr","around-sm":"src-components-Nav----styles-module---around-sm---1D2K5","between-sm":"src-components-Nav----styles-module---between-sm---3hgGM","first-sm":"src-components-Nav----styles-module---first-sm---CYgT8","last-sm":"src-components-Nav----styles-module---last-sm---jvv3e","col-md":"src-components-Nav----styles-module---col-md---2xui3","col-md-1":"src-components-Nav----styles-module---col-md-1---2AdFW","col-md-2":"src-components-Nav----styles-module---col-md-2---43byq","col-md-3":"src-components-Nav----styles-module---col-md-3---3cCHc","col-md-4":"src-components-Nav----styles-module---col-md-4---2-qgs","col-md-5":"src-components-Nav----styles-module---col-md-5---3PxgW","col-md-6":"src-components-Nav----styles-module---col-md-6---27OiU","col-md-7":"src-components-Nav----styles-module---col-md-7---2Y9Ix","col-md-8":"src-components-Nav----styles-module---col-md-8---1LRiZ","col-md-9":"src-components-Nav----styles-module---col-md-9---1x8Pd","col-md-10":"src-components-Nav----styles-module---col-md-10---3KJ3g","col-md-11":"src-components-Nav----styles-module---col-md-11---3mD_w","col-md-12":"src-components-Nav----styles-module---col-md-12---BvEqm","col-md-offset-1":"src-components-Nav----styles-module---col-md-offset-1---1Wppf","col-md-offset-2":"src-components-Nav----styles-module---col-md-offset-2---2rWPT","col-md-offset-3":"src-components-Nav----styles-module---col-md-offset-3---3k40Z","col-md-offset-4":"src-components-Nav----styles-module---col-md-offset-4---2Q0XE","col-md-offset-5":"src-components-Nav----styles-module---col-md-offset-5---3AQMZ","col-md-offset-6":"src-components-Nav----styles-module---col-md-offset-6---1E9R6","col-md-offset-7":"src-components-Nav----styles-module---col-md-offset-7---3aekw","col-md-offset-8":"src-components-Nav----styles-module---col-md-offset-8---3Meqe","col-md-offset-9":"src-components-Nav----styles-module---col-md-offset-9---1YPFb","col-md-offset-10":"src-components-Nav----styles-module---col-md-offset-10---32eBH","col-md-offset-11":"src-components-Nav----styles-module---col-md-offset-11---1sUmE","start-md":"src-components-Nav----styles-module---start-md---2fNZ0","center-md":"src-components-Nav----styles-module---center-md---2hnRh","end-md":"src-components-Nav----styles-module---end-md---Jhdej","top-md":"src-components-Nav----styles-module---top-md---3mdwo","middle-md":"src-components-Nav----styles-module---middle-md---RuyRp","bottom-md":"src-components-Nav----styles-module---bottom-md---2UOW8","around-md":"src-components-Nav----styles-module---around-md---etVi3","between-md":"src-components-Nav----styles-module---between-md---1AVJa","first-md":"src-components-Nav----styles-module---first-md---11FFn","last-md":"src-components-Nav----styles-module---last-md---1x5hD","col-lg":"src-components-Nav----styles-module---col-lg---1Gq9q","col-lg-1":"src-components-Nav----styles-module---col-lg-1---XWvEF","col-lg-2":"src-components-Nav----styles-module---col-lg-2---3lSO9","col-lg-3":"src-components-Nav----styles-module---col-lg-3---3rWnw","col-lg-4":"src-components-Nav----styles-module---col-lg-4---2gKqj","col-lg-5":"src-components-Nav----styles-module---col-lg-5---1M1CO","col-lg-6":"src-components-Nav----styles-module---col-lg-6---rgGtN","col-lg-7":"src-components-Nav----styles-module---col-lg-7---1HLe6","col-lg-8":"src-components-Nav----styles-module---col-lg-8---3KKwr","col-lg-9":"src-components-Nav----styles-module---col-lg-9---x2FGe","col-lg-10":"src-components-Nav----styles-module---col-lg-10---1hjPk","col-lg-11":"src-components-Nav----styles-module---col-lg-11---Z9XaR","col-lg-12":"src-components-Nav----styles-module---col-lg-12---3MpTk","col-lg-offset-1":"src-components-Nav----styles-module---col-lg-offset-1---Bned3","col-lg-offset-2":"src-components-Nav----styles-module---col-lg-offset-2---3xwEO","col-lg-offset-3":"src-components-Nav----styles-module---col-lg-offset-3---2IwIL","col-lg-offset-4":"src-components-Nav----styles-module---col-lg-offset-4---3iIVp","col-lg-offset-5":"src-components-Nav----styles-module---col-lg-offset-5---r84rx","col-lg-offset-6":"src-components-Nav----styles-module---col-lg-offset-6---1JOKT","col-lg-offset-7":"src-components-Nav----styles-module---col-lg-offset-7---1AYtJ","col-lg-offset-8":"src-components-Nav----styles-module---col-lg-offset-8---16Uf8","col-lg-offset-9":"src-components-Nav----styles-module---col-lg-offset-9---1wDEQ","col-lg-offset-10":"src-components-Nav----styles-module---col-lg-offset-10---ZSDlo","col-lg-offset-11":"src-components-Nav----styles-module---col-lg-offset-11---1v_Ab","start-lg":"src-components-Nav----styles-module---start-lg---1I6SC","center-lg":"src-components-Nav----styles-module---center-lg---1T1to","end-lg":"src-components-Nav----styles-module---end-lg---Bnjc4","top-lg":"src-components-Nav----styles-module---top-lg---OPEOc","middle-lg":"src-components-Nav----styles-module---middle-lg---10ali","bottom-lg":"src-components-Nav----styles-module---bottom-lg---2u66H","around-lg":"src-components-Nav----styles-module---around-lg---10Ew2","between-lg":"src-components-Nav----styles-module---between-lg---244Xy","first-lg":"src-components-Nav----styles-module---first-lg---NLzEE","last-lg":"src-components-Nav----styles-module---last-lg---3Dr2T","menu-list":"src-components-Nav----styles-module---menu-list---JLW-i","menu-link":"src-components-Nav----styles-module---menu-link---KU0z1","underLine-container":"src-components-Nav----styles-module---underLine-container---T21oz","hero":"src-components-Nav----styles-module---hero---3pee3","hero__content":"src-components-Nav----styles-module---hero__content---2w1QF","hero_title":"src-components-Nav----styles-module---hero_title---wRgwy","hero__list-line":"src-components-Nav----styles-module---hero__list-line---V737a","hero__list":"src-components-Nav----styles-module---hero__list---3U-po","hero__list-item":"src-components-Nav----styles-module---hero__list-item---NaJmU","std-header__bg-wrap":"src-components-Nav----styles-module---std-header__bg-wrap---1F6gZ","std-header__bg":"src-components-Nav----styles-module---std-header__bg---3t4Bo","home--section-bar":"src-components-Nav----styles-module---home--section-bar---2kh2n","home-recent--project":"src-components-Nav----styles-module---home-recent--project---3GCjP","home-recent--project--image":"src-components-Nav----styles-module---home-recent--project--image---3Q-Mq","home-recent--project--image--con":"src-components-Nav----styles-module---home-recent--project--image--con---ngKhB","home-recent--project--image--bg":"src-components-Nav----styles-module---home-recent--project--image--bg---374i9","home-recent--project--details-wrap":"src-components-Nav----styles-module---home-recent--project--details-wrap---19Rnz","home-recent--project--details--name":"src-components-Nav----styles-module---home-recent--project--details--name---1NbWX","home-recent--project--details--type":"src-components-Nav----styles-module---home-recent--project--details--type---2JFgP","home-recent--project--details--para":"src-components-Nav----styles-module---home-recent--project--details--para---382uM","cs-home-about--text":"src-components-Nav----styles-module---cs-home-about--text---71Z13","cur-next-slide":"src-components-Nav----styles-module---cur-next-slide---3CKh-","nav":"src-components-Nav----styles-module---nav---8qGdf"};

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _scrollmagic = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollMagicContext = (_temp2 = _class = function (_Component) {
	  _inherits(ScrollMagicContext, _Component);
	
	  function ScrollMagicContext() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScrollMagicContext);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { scrollmagic: new _scrollmagic.Controller() }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ScrollMagicContext.prototype.getChildContext = function getChildContext() {
	    return { scrollmagic: this.state.scrollmagic };
	  };
	
	  ScrollMagicContext.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    if (nextProps.location.pathname === this.props.location.pathname) return;
	    this.resetController();
	  };
	
	  ScrollMagicContext.prototype.resetController = function resetController() {
	    this.state.scrollmagic.destroy();
	    this.setState({ scrollmagic: new _scrollmagic.Controller() });
	  };
	
	  ScrollMagicContext.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  _createClass(ScrollMagicContext, null, [{
	    key: 'childContextTypes',
	    get: function get() {
	      return { scrollmagic: _propTypes2.default.any };
	    }
	  }]);
	
	  return ScrollMagicContext;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.any,
	  location: _propTypes2.default.any
	}, _temp2);
	exports.default = ScrollMagicContext;
	module.exports = exports['default'];

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _ScrollMagicContext = __webpack_require__(418);
	
	var _ScrollMagicContext2 = _interopRequireDefault(_ScrollMagicContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ScrollMagicContext2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App = __webpack_require__(369);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Footer = __webpack_require__(374);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Nav = __webpack_require__(412);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Link = __webpack_require__(41);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__(882);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children,
	      location = _ref.location;
	
	  console.log(children);
	  return _react2.default.createElement(
	    _App2.default,
	    { location: location },
	    _react2.default.createElement(
	      'header',
	      { className: 'header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header__bar', style: { display: 'flex', justifyContent: 'space-between' } },
	        _react2.default.createElement(
	          _Link2.default,
	          { to: '/', className: 'logo' },
	          _react2.default.createElement('img', { src: 'https://studiogritt.files.wordpress.com/2018/04/logod12x-1.png', style: { width: '140px' } })
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'menu-list' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _Link2.default,
	              { className: 'menu-link', to: '/about' },
	              _react2.default.createElement('span', { className: 'underLine-container' }),
	              'About'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _Link2.default,
	              { className: 'menu-link', to: '/architecture' },
	              _react2.default.createElement('span', { className: 'underLine-container' }),
	              'Architecture'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _Link2.default,
	              { className: 'menu-link', to: '/interiors' },
	              _react2.default.createElement('span', { className: 'underLine-container' }),
	              'Interiors'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _Link2.default,
	              { className: 'menu-link', to: '/products' },
	              _react2.default.createElement('span', { className: 'underLine-container' }),
	              'Products'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _Link2.default,
	              { className: 'menu-link', to: '/blogs' },
	              _react2.default.createElement('span', { className: 'underLine-container' }),
	              'Blogs'
	            )
	          )
	        ),
	        _react2.default.createElement(_Nav2.default, { location: location })
	      )
	    ),
	    children(),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.any,
	  location: _propTypes2.default.object
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-943778d4ce1308f6ac28.js